import { atom } from "recoil";
import { Company, School } from "../apis";

const KEY = "action-school-or-company";

export const ActiveSchoolOrCompanyAtom = atom<Company | School | null>({
    key: KEY,
    default: null,
});
